module.exports = __webpack_public_path__ + "img/scroll-old.396c8538.svg";